<template>
    <v-app>
        <v-container fluid>
            <template v-if="$insertAccess($route.path)">
                <v-form @submit.prevent="submit">
                    <v-row>
                        <v-col cols="12">
                            <v-expansion-panels v-model="panel" >
                                <v-expansion-panel>
                                    <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header"><span>{{ isEntryMode ? "Add Attendance Reconciliation" : "Update Attendance Reconciliation" }}</span></v-expansion-panel-title>
                                    <v-expansion-panel-text> 
                                        <v-row class="pt-2 px-2 justify-space-around align-end">
                                            
                                            <v-col md="3" cols="12">

                                                <v-date-input
                                                label="Attendance Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="attendance_date.value.value"
                                                :error-messages="attendance_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                                >
                                                    <template #label>
                                                        Attendance Date <span class="text-red-accent-4">*</span>
                                                    </template> 
                                                </v-date-input>

                                                <v-autocomplete
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="employee_id.value.value"
                                                :error-messages="employee_id.errorMessage.value"
                                                clearable
                                                :items="getHrmEmployeeList"
                                                :item-title="item => `${item.name}-${item.code}`"   
                                                autocomplete="off"                                               
                                                item-value="id"
                                                :loading="employeeLoading"
                                                >
                                                    <template #label>
                                                        Employee <span class="text-red-accent-4">*</span>
                                                    </template> 
                                                </v-autocomplete>

                                                <v-text-field
                                                :model-value="actual_in.value.value"
                                                :error-messages="actual_in.errorMessage.value"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                label="Actual In Time"
                                                prepend-inner-icon="mdi-clock-time-four-outline"
                                                readonly
                                                >
                                                    <v-menu
                                                    v-model="actualInMenu"
                                                    :close-on-content-click="false"
                                                    activator="parent"
                                                    min-width="0"
                                                    >
                                                        <v-time-picker 
                                                        v-model="actual_in.value.value"
                                                        ></v-time-picker>
                                                    </v-menu>
                                                </v-text-field>

                                                <v-text-field
                                                :model-value="actual_out.value.value"
                                                :error-messages="actual_out.errorMessage.value"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                label="Actual Out Time"
                                                prepend-inner-icon="mdi-clock-time-four-outline"
                                                readonly
                                                >
                                                    <v-menu
                                                    v-model="actualOutMenu"
                                                    :close-on-content-click="false"
                                                    activator="parent"
                                                    min-width="0"
                                                    >
                                                        <v-time-picker 
                                                        v-model="actual_out.value.value"
                                                        ></v-time-picker>
                                                    </v-menu>
                                                </v-text-field>
                                            </v-col>

                                            <v-col cols="9">
                                                <v-textarea
                                                label="In Remarks"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="in_remarks.value.value"
                                                :error-messages="in_remarks.errorMessage.value"
                                                autocomplete="off"
                                                rows="3"
                                                clearable
                                                ></v-textarea>
                                                <v-textarea
                                                label="Out Remarks"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="out_remarks.value.value"
                                                :error-messages="out_remarks.errorMessage.value"
                                                autocomplete="off"
                                                rows="3"
                                                clearable
                                                ></v-textarea>
                                            </v-col>

                                        </v-row>

                                        <v-divider></v-divider>

                                        <v-card-actions>
                                            <v-row class="pt-2">
                                                
                                                <v-col cols="12">
                                                    <v-layout class="justify-end">
                                                        <!-- <v-btn
                                                            class="bg-grey-darken-1 me-2"
                                                            variant="flat"
                                                            @click="submitForm(0)"
                                                            >DRAFT</v-btn
                                                        > -->
                                                        <v-btn
                                                        class="bg-primary"
                                                        variant="flat"
                                                        @click="submitForm(1)"
                                                        >POST</v-btn>
                                                    </v-layout>
                                                </v-col>

                                            </v-row>
                                        </v-card-actions>

                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                    </v-row>
                </v-form>
            </template>
        </v-container>
    </v-app>
</template>

<script>

import {useStore} from 'vuex';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { ref } from 'vue';
import { toast } from 'vue3-toastify';
import { useRouter } from 'vue-router'; 
import formattedDate from '@/plugins/dateFormatter';

export default {
    components: {},
    data: () => ({
        itemsPerPage:10,
        panel: [0],
        search: "",
        data: {},
        employeeLoading: false,
        actualInMenu: false,
        actualOutMenu: false,
    }),

    watch: {},
    created() {
        if(this.$store.getters.getHrmEmployeeList.length === 0) {
            this.employeeLoading = true;
            this.$store.dispatch("getHrmEmployeeList").then((response) => {
                this.employeeLoading = false;
            })
        }
    },
    computed: {
        getHrmEmployeeList() {
            return this.$store.getters.getHrmEmployeeList;
        }
    },

    methods: {
        resetForm() {
            this.data = {};
        },
    },

    setup() {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                attendance_date: yup.date().required().label("Attendance Date"),
                employee_id: yup.string().required().label("Employee ID"),
                actual_in: yup.string().nullable(),
                in_remarks: yup.string()
                    .nullable()
                    .when("actual_in", {
                        is: (val) => !!val,
                        then: (schema) => schema.required("In Remarks is required when In Time is provided"),
                        otherwise: (schema) => schema.nullable()
                    })
                    .label("In Remarks"),

                actual_out: yup.string().nullable(),
                out_remarks: yup.string()
                    .nullable()
                    .when("actual_out", {
                        is: (val) => !!val,
                        then: (schema) => schema.required("Out Remarks is required when Out Time is provided"),
                        otherwise: (schema) => schema.nullable()
                    })
                    .label("Out Remarks"),
            }),
        });


        const attendance_reconciliation_id = useField("attendance_reconciliation_id");
        const attendance_date = useField('attendance_date');
        const employee_id = useField('employee_id');
        const actual_in = useField('actual_in');
        const actual_out = useField('actual_out');
        const in_remarks = useField('in_remarks');
        const out_remarks = useField('out_remarks');
        
        const errorMessages  = ref('');
        const loading  = ref('');
        const isEntryMode = ref(true);

        const store = useStore();
        const router = useRouter();

        const currentStatus = ref(0);

        const submitForm = (status) => {
            currentStatus.value = status;
            submit();
        };

        const submit = handleSubmit((values) => { 
            const formData = new FormData();
            values.attendance_date = formattedDate(attendance_date.value.value);
            values.actual_in  = values.actual_in ? values.actual_in.slice(0,5) : null;
            values.actual_out = values.actual_out ? values.actual_out.slice(0, 5) : null;

            Object.keys(values).forEach((key) => {
                formData.append(key, values[key] || "");
            });

            formData.append('status', currentStatus.value);

            store.dispatch("saveUpdateAttendanceReconciliation", formData) 
                .then((response) => {  
                    resetForm();
                    toast.success(response.data.message, {
                        timeout: 3000,
                    });
                    store.dispatch("getAttendanceReconciliationList")
                    setTimeout(() => {  
                        router.push({ name: "reconciliation-records" });
                    }, 2000);
                })
                .catch((error) => { 
                    loading.value = false;
                    toast.error(error.response.data.message);      
            })
        })
        return {
        submit,
        submitForm,
        attendance_reconciliation_id,
        attendance_date,
        actual_in,
        actual_out,
        in_remarks,
        out_remarks,
        employee_id,
        errorMessages,
        isEntryMode,
        resetForm,
        loading
        }
    },
    mounted() {

        if (this.$store.getters.getEditingAttendanceReconciliation) {
            const data = this.$store.getters.getEditingAttendanceReconciliation;
            this.$store.commit('SET_LOADING', { color: 'primary' });
            
            this.isEntryMode = false;

            this.attendance_reconciliation_id.value.value = data.id;
            this.attendance_date.value.value = data.date;
            this.employee_id.value.value = data.employee_id || null;
            this.actual_in.value.value = data.actual_in? data.actual_in.slice(0,5) : null;
            this.actual_out.value.value = data.actual_out? data.actual_out.slice(0,5) : null;
            this.in_remarks.value.value = data.in_remarks;
            this.out_remarks.value.value = data.out_remarks;

            this.$store.commit('UNSET_LOADING');
        }
    },
    beforeUnmount() {
        this.$store.commit('UNSET_EDITING_ATTENDANCE_RECONCILIATION');
    }
}
</script>
